import { faBox, faCalendarRange, faHashtag } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IProduct } from '@feathr/blackbox';
import { SummaryCard, TimeRange } from '@feathr/components';
import { TimeFormat } from '@feathr/hooks';

interface IServiceDetailsCardProps {
  name: IProduct['name'];
  opp_id: IProduct['opp_id'];
  period: IProduct['period'];
}

function PackageDetailsCard({
  name,
  opp_id: oppId,
  period,
}: Readonly<IServiceDetailsCardProps>): JSX.Element {
  const { t } = useTranslation();
  const { start, end } = period;
  return (
    <SummaryCard name={'package-details'}>
      <SummaryCard.Item icon={faBox} label={t('Package')}>
        {name}
      </SummaryCard.Item>
      <SummaryCard.Item icon={faHashtag} label={t('Opportunity ID')}>
        {oppId}
      </SummaryCard.Item>
      <SummaryCard.Item icon={faCalendarRange} label={t('License period')}>
        <TimeRange end={end} format={TimeFormat.pickerDateTime} start={start} />
      </SummaryCard.Item>
    </SummaryCard>
  );
}

export default PackageDetailsCard;
